export default {
  'bindTo': 'this',
  'method': function(){
    alert('Estratto Conto CSV')
  },
}
